import { autoinject } from 'aurelia-framework';
import { SystemFileStorageService } from 'services/system-file-storage-service';

@autoinject()
export class Preview {

  pdfUrl: string | null = null;

  constructor(private fileService: SystemFileStorageService){}


  async activate(args: {fileId:string}){
    if (!args.fileId) {
      return;
    }
    const fileId = parseInt(args.fileId, 10);
    const file = (await this.fileService.download(fileId, false, true)) as Blob;
    const blob = new Blob([file], { type: 'application/pdf' });
    this.pdfUrl = URL.createObjectURL(blob);
  }

}
